import React from 'react';
import {TableCell, TableRow, Typography} from "@mui/material";
import {UseFormReturn} from "react-hook-form";
import {FormOperacionLCTC} from "../types/types";
import {OperacionLCTCCuentaFields} from "../types/fields";
import {OperacionLCLTCampoLimite} from "./OperacionLCLTCampoLimite";
import {useLoadOptions} from "../../../../../hooks/useLoadOptions";
import {useLCTCLimiteTipos} from "../hooks/useLCTCCache";

interface OperacionLCTCFilaCuentaProps {
    formMethods: UseFormReturn<FormOperacionLCTC>;
    index: number;
}

export const OperacionLCTCFilaCuenta = ({ formMethods, index }: OperacionLCTCFilaCuentaProps) => {
    const { control, getValues } = formMethods;

    const cuenta = getValues(`cuentas.${index}`);

    const limitesTipos = useLCTCLimiteTipos();
    const loadLimites = useLoadOptions({
        data: limitesTipos.limiteTipos,
        loading: limitesTipos.isLoading,
        isError: limitesTipos.isError,
        error: limitesTipos.error
    });

    return (
        <TableRow>
            <TableCell>
                <Typography>{cuenta[OperacionLCTCCuentaFields.DescClienteTipo]}</Typography>
            </TableCell>
            <TableCell>
                <Typography>{cuenta[OperacionLCTCCuentaFields.DescClienteSubTipo] ?? '-'}</Typography>
            </TableCell>
            <TableCell>
                <OperacionLCLTCampoLimite
                    control={control}
                    name={`cuentas.${index}.${OperacionLCTCCuentaFields.LimiteConcertacion}`}
                    label='Límite Concertación (% del AUM)'
                    loadOptions={loadLimites}
                />
            </TableCell>
            {/* <TableCell>
                <OperacionLCLTCampoLimite
                    control={control}
                    name={`cuentas.${index}.${OperacionLCTCCuentaFields.LimiteLiquidacionDVP}`}
                    label='Límite DVP'
                    loadOptions={loadLimites}
                />
            </TableCell>
            <TableCell>
                <OperacionLCLTCampoLimite
                    control={control}
                    name={`cuentas.${index}.${OperacionLCTCCuentaFields.LimiteLiquidacionFOP}`}
                    label='Límite FOP'
                    loadOptions={loadLimites}
                />
            </TableCell> */}
        </TableRow>
    );
};
